import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RopeShovelInspectionComponent } from './pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { SharedModule } from '../../shared/shared.module';
import { MaterialModule } from '../../shared/material.module';
import { EquipmentPhotosComponent } from './components/equipment-photos/equipment-photos.component';
import { RouterModule, Routes } from '@angular/router';
import { EquipmentPhotoComponent } from './components/equipment-photo/equipment-photo.component';
import { AdditionalRecordTextComponent } from './components/additional-record-text/additional-record-text.component';
import { AdditionalRecordYesnoComponent } from './components/additional-record-yesno/additional-record-yesno.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdditionalRecordsComponent } from './components/additional-records/additional-records.component';
import { MandatoryComponentPhotosComponent } from './components/mandatory-component-photos/mandatory-component-photos.component';
import { MandatoryComponentPhotoComponent } from './components/mandatory-component-photo/mandatory-component-photo.component';
import { ComponentMeasurementTableComponent } from './components/component-measurement-table/component-measurement-table.component';
import { ComponentPhotoSmallComponent } from './components/component-photo-small/component-photo-small.component';
import { MeasurementPointsComponent } from './components/measurement-points/measurement-points.component';
import { ViewPhotoComponent } from './components/view-photo/view-photo.component';
import { ReportBuilderComponent } from './pages/report-builder/report-builder.component';
import { AddReportItemsComponent } from './pages/report-builder/add-report-items/add-report-items.component';
// Pipes
import { EditDataComponent } from '../wsre/components/edit-data/edit-data.component'

// Service
import { ReportBuilderService } from './pages/report-builder/report-builder.service';
import { MeasurementPointReadingsComponent } from './pages/report-builder/measurement-point-readings/measurement-point-readings.component';
import { MeasurementPointPhotosComponent } from './pages/report-builder/measurement-point-photos/measurement-point-photos.component';
import { RecommendedActionComponent } from './pages/report-builder/recommended-action/recommended-action.component';
import { AddPhotoModalComponent } from './pages/report-builder/add-photo-modal/add-photo-modal.component';
import { AdditionalRecordComponent } from './pages/report-builder/additional-record/additional-record.component';
import { CalculatedFieldsComponent } from './components/calculated-fields/calculated-fields.component';
import { UploadComponentPhotoComponent } from './components/upload-component-photo/upload-component-photo.component';
import { SendReportModalComponent } from './pages/report-builder/send-report-modal/send-report-modal.component';
import { DeleteConfirmationDialogComponent } from './components/delete-confirmation-dialog/delete-confirmation-dialog.component';
import { AdditionalRecordNumberComponent } from './components/additional-record-number/additional-record-number.component';
import { AdditionalRecordImageComponent } from './components/additional-record-image/additional-record-image.component';
import { rsreportconfigcomponent } from './components/report-configuration/rs-report-config.component';

export const ropeShovelInspectionRoutes: Routes = [{
  path: 'rs-inspection/equipment/:EquipmentId',
  component: RopeShovelInspectionComponent,
  children: [
    { path: 'photos', component: EquipmentPhotosComponent }
  ]
},
  {
    path: 'rs-inspection/equipment/:EquipmentId/inspection/:InspectionId',
    component: RopeShovelInspectionComponent,
    children: [
      { path: 'photos', component: EquipmentPhotosComponent }
    ]
  },
  {
    path: 'rs-inspection/:InspectionId',
    component: RopeShovelInspectionComponent,
    children: [
      { path: 'photos', component: EquipmentPhotosComponent }
    ]
  }];

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forChild(ropeShovelInspectionRoutes),
    ],
    declarations: [
        EquipmentPhotosComponent, EquipmentPhotoComponent, AdditionalRecordTextComponent, AdditionalRecordYesnoComponent, AdditionalRecordsComponent, MandatoryComponentPhotosComponent, MandatoryComponentPhotoComponent, ComponentMeasurementTableComponent, ComponentPhotoSmallComponent, MeasurementPointsComponent, ViewPhotoComponent,
        RopeShovelInspectionComponent, ReportBuilderComponent, AddReportItemsComponent, MeasurementPointReadingsComponent, MeasurementPointPhotosComponent, RecommendedActionComponent, AddPhotoModalComponent, AdditionalRecordComponent, CalculatedFieldsComponent, UploadComponentPhotoComponent, SendReportModalComponent, DeleteConfirmationDialogComponent, AdditionalRecordNumberComponent,
        AdditionalRecordImageComponent, rsreportconfigcomponent,AdditionalRecordImageComponent, rsreportconfigcomponent
    ],
    providers: [
        ReportBuilderService, DatePipe
    ]
})
export class RopeShovelModule { }
